class FunctionalityDefinitions {
  static findBySubType(definitions, lookUpSubType) {
    return definitions.find(({ subType }) => subType === lookUpSubType)
  }
}

export default FunctionalityDefinitions
